import { AfterViewInit, Component, DoCheck, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Form } from "@angular/forms";
import { Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../../../service/auth-service/auth.service";
import { sweetAlert } from "../../../utils/swal";
import { takeUntil } from "rxjs/operators";
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { ServiceAreasService } from "../service-areas-service/service-areas.service";

@Component({
  selector: 'app-service-areas-add',
  templateUrl: './service-areas-add.component.html',
  styleUrls: ['./service-areas-add.component.css']
})
export class ServiceAreasAddComponent implements OnInit {
  serviceAreaForm: UntypedFormGroup;
  zipCodeForm: UntypedFormGroup
  submitted = false;
  zipCodeSubmitted = false;
  userId = null;
  serviceAreaId;
  zipCodeArray = [];

  constructor(
    public authService: AuthService,
    private serviceArea: ServiceAreasService,
    private activatedRoute: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private router: Router
  ) { }

  ngOnInit() {
    this.activatedRoute.params
    .pipe(takeUntil(takeUntilDestroyed(this)))
    .subscribe((params) => {
      this.serviceAreaId = params["id"];
      if(this.serviceAreaId){
        this.getServiceAreabyId();
      }
    });

    this.serviceAreaForm = this.fb.group({
      name: ["", Validators.required],
      status: ['active', Validators.required],
      zipCodes: [[]]
    });

    this.zipCodeForm = this.fb.group({
      zipCode:['',Validators.required]
    })

  }

  addZipCode() {
    this.submitted = true;
    this.zipCodeSubmitted = true;
    if (this.zipCodeForm.invalid) {
      return;
    }
    for(let item of this.zipCodeArray){
      this.serviceAreaForm.value.zipCodes.push(item);
    }
    this.zipCodeArray= [];
    this.zipCodeForm.reset();
    this.zipCodeSubmitted = false;
    this.submitted = false;
  }

  removeZipCode(index) {
    const z1 = this.serviceAreaForm.value.zipCodes;
    z1.splice(index, 1);
    this.serviceAreaForm.patchValue({
      zipCodes: z1
    });
  }

  getServiceAreabyId(){
    this.serviceArea.getServiceAreasbyId(this.serviceAreaId)
    .pipe(takeUntil(takeUntilDestroyed(this)))
    .subscribe(
      (data) => {
        if (data) {
          this.serviceAreaForm.patchValue(data)
        }
      },
      (err) => {
        sweetAlert("Error", err, "error", "Ok");
      }
    );
  }

  onInputChange(event: any) {
    const inputValue = event.target.value;
    if (inputValue) {
      const values = inputValue.split(',');
       this.zipCodeArray = values.map(value => value.trim());
    }
  }


  saveStaff() {
    this.submitted = true;
    if (this.serviceAreaForm.invalid || this.serviceAreaForm.value.zipCodes.length === 0) {
      this.zipCodeSubmitted = true;
      return;
    } else {
      let payload = this.serviceAreaForm.value;
      this.serviceArea.addServiceAreas(payload,this.serviceAreaId)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.router.navigateByUrl("fleet/service-areas");
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
    }
  }

  get form() {
    return this.serviceAreaForm.controls;
  }
  get formControl(){
    return this.zipCodeForm.controls;
  }


ngOnDestroy(): void {
}

}
